
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-opacity",
  "use": "icon-material-opacity-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-opacity\"><path d=\"M479.95-114.02q-135.34 0-230.63-92.18-95.3-92.17-95.3-227.5 0-67.41 25.86-125.77t71.02-103.04L480-888.61l229.1 226.1q45.16 44.68 71.14 103.04t25.98 125.77q0 135.33-95.47 227.5-95.47 92.18-230.8 92.18M225.15-400h510.18q11.8-68.04-14.76-124.97Q694-581.89 666-608.89l-186-183-186 183q-28 27-54.45 83.92-26.44 56.93-14.4 124.97\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-opacity"/>
                </svg>
            );
        };

        Icon.id = "icon-material-opacity";

        export default Icon;
    